<template>
  <div class="page_content">
    
		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading">
				<span class="module_icon fas fa-folder"></span>
				<span class="module_type_name">Folder Management :: {{ title }}</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button type="button" class="btn btn-primary" @click="saveAndDone" aria-label="save & done">save & done</button>
				<button type="button" class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
			</div>
		</div>

        <b-container fluid class="facets-search-grid-container">
            <b-row>
                <div class="facets facets-role-col col-3">
                    <div class="search-row">
                        <input type="text" class="input-search" placeholder="search by name" aria-label="search by name" v-model.trim="searchTerm" @input="searchUser" style="float: left;">
                        <div class="clear-btn" v-if="this.searchTerm.length > 0" @click="searchUser">
							<b-btn @click="searchTerm = ''" aria-label="clear">X</b-btn>
						</div>
                        <!--
                        <input type="text" class="input-search" placeholder="search user" v-on:keyup.enter="searchUser" aria-label="search user" v-model.trim="searchTerm">
                        <button type="button" class="btn btn-primary" @click="searchUser" aria-label="go">Go</button>
                        -->
                    </div>
                    <div class="main_head">
                        <span class="head_txt">Narrow Your Results</span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="head">
                                <div class="head_txt">Role</div>
                            </div>

                            <div class="facet_row_container">
                                <b-form-group>
                                    <b-form-checkbox-group plain stacked v-model="selectedRoles" :options="userRoles" @input="getUsersForRole" />
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-user-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Users</span>
                        <span class="float-right">
                            <button type="button" class="btn btn-primary" @click="enrollUsers" aria-label="enroll" :disabled="(selectedUsers.length === 0)">enroll</button>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <template v-if="shouldShowNoResultFound">
                                    <span class="no-result">No results found!</span>
                                </template>
                                <template v-else>
                                    <b-form-group>
                                        <b-form-checkbox-group plain stacked v-model="selectedUsers" @input="changeSelectedUsers">
                                            <template v-for="user in userList">
                                                <b-form-checkbox :value="user" :disabled="user.special" :class="{'special': user.special}"><span class="check-description">{{ user.title }}</span></b-form-checkbox>
                                            </template>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets facets-enrolledUser-col col-4">
                    <div class="main_head">
                        <span class="head_txt">Enrolled Users</span>
                        <span class="float-right">
                            <span @click="deleteEnrolledUsers" :class="{'icon-bin': true, 'action-link': (selectedEnrolledUsers.length > 0)}" :disabled="(selectedEnrolledUsers.length === 0)" aria-label="delete" tabindex="0"></span>
                        </span>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group>
                                    <b-form-checkbox-group plain stacked v-model="selectedEnrolledUsers" @input="changeSelectedEnrolledUsers">
                                        <template v-for="enrolledUser in enrolledUserList">
                                            <b-form-checkbox :value="enrolledUser" :disabled="enrolledUser.disabled"><span class="check-description">{{ enrolledUser.title }}</span></b-form-checkbox>
                                        </template>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import _ from 'lodash'
  import '../../../assets/module/less/folder-management.less'

  export default {
    name: 'folder-edit',
    props: ['uuid', 'ownerId', 'title'],
    data () {
      return {
        pageSize: 100,
        users: [],
        userList: [],
        enrolledUserList: [],
        selectedUsers: [],
        selectedEnrolledUsers: [],
        userRoles: ['Admin', 'Instructor', 'Curator'],
        selectedRoles: ['Admin', 'Instructor', 'Curator'],
        actionType: {ENROLL: 'ENROLL', UNENROLL: 'UNENROLL'},
        searchTerm: '',
        shouldShowNoResultFound: false
      }
    },

    mounted () {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.getEnrolledUserListWithUserList()
        this.$refs.loadingModal.hide()
      }, 500)
    },

    computed: {
      currentInstitutionId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.institutionId
      },

      loggedInUserId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.uuid
      }
    },

    methods: {
      ...mapActions([
        'loadUsersForRole',
        'loadEnrolledUsers',
        'updateInstitutionPrivateLibrary'
      ]),

      getEnrolledUserListWithUserList () {
        this.loadEnrolledUsers(this.uuid).then(res => {
          this.enrolledUserList = []
          $.each(res.content, (i, user) => {
            var result = {
              uuid: user.uuid,
              title: user.firstName + ' ' + user.lastName,
              roles: user.roles,
              isSelected: '',
              action: '',
              disabled: (this.ownerId === user.uuid)
            }
            this.enrolledUserList.push(result)
          })
          this.getUsersForRole()
        })
      },

      getUsersForRole () {
        var roles = this.getSelectedRoles()
        var searchString = $.trim(this.searchTerm)
        var name = (searchString.length === 0) ? undefined : searchString
        this.fetchUsersForRole(roles, this.currentInstitutionId, 0, this.pageSize, name)
      },

      getSelectedRoles () {
        var roleString = ''
        var roles = this.selectedRoles
        for (var i = 0; i < roles.length; i++) {
          roleString += roles[i]
          if (i < (roles.length - 1)) {
            roleString += '|'
          }
        }
        return roleString
      },

      fetchUsersForRole (role, parentSpaceId, page, pageSize, name) {
        var data = {
          role: role,
          parentSpaceId: parentSpaceId,
          page: page,
          count: pageSize,
          name: name
        }
        this.loadUsersForRole(data).then(res => {
          this.userList = []
          $.each(res.content, (i, user) => {
            var result = {
              uuid: user.uuid,
              title: user.firstName + ' ' + user.lastName,
              roles: user.roles,
              isSelected: '',
              action: ''
            }
            this.userList.push(result)
          })
          if (this.userList.length > 0) {
            this.shouldShowNoResultFound = false
            this.userList = this.postProcessSearch(this.userList, this.enrolledUserList)
          } else {
            this.shouldShowNoResultFound = true
          }
        })
      },

      postProcessSearch (fromList, toList) {
        $.each(fromList, (i, fromListItem) => {
          $.each(toList, (j, toListItem) => {
            if (fromListItem.uuid === toListItem.uuid) {
              if (toListItem.action !== 'UNENROLL') {
                fromListItem['special'] = true
                fromListItem.isSelected = false
              } else if (toListItem.action === 'UNENROLL') {
                fromListItem['special'] = false
              }
            }
          })
        })
        return fromList
      },

      changeSelectedUsers () {
        $.each(this.userList, (i, entity) => {
          entity.isSelected = false
        })
        this.selectedUsers.forEach((user) => {
          user.isSelected = true
        })
      },

      changeSelectedEnrolledUsers () {
        this.selectedEnrolledUsers.forEach((user) => {
          user.isSelected = true
        })
      },

      enrollUsers () {
        this.processEnrollAction(this.actionType.ENROLL)
        this.selectedUsers = []
      },

      processEnrollAction (action) {
        var enrolledUsers = []
        $.each(this.userList, (i, entity) => {
          if (entity.isSelected && !entity.special) {
            entity.action = action
            enrolledUsers.push(entity)
          }
        })
        this.enrolledUserList = _.unionBy(this.enrolledUserList, enrolledUsers, 'uuid')
        this.userList = this.postProcessSearch(this.userList, this.enrolledUserList)
      },

      deleteEnrolledUsers () {
        this.processUnenrollAction(this.actionType.UNENROLL)
        this.selectedEnrolledUsers = []
      },

      processUnenrollAction (action) {
        $.each(this.selectedEnrolledUsers, (i, entity) => {
          entity.isSelected = false
          const index = this.enrolledUserList.indexOf(entity)
          this.enrolledUserList.splice(index, 1)
          this.userList.forEach((user) => {
            if (user.uuid === entity.uuid) {
              user.special = false
            }
          })
        })
      },

      cancel () {
        return this.$router.push({name: 'folderList'})
      },

      saveAndDone () {
        this.$refs.loadingModal.show()
        var arrayOfUUID = this.getListOfUUIDsOfEnrolledUser()
        var data = {
          _class: 'com.pragyasystems.knowledgeHub.api.security.Group',
          uuid: this.uuid,
          userUuidList: arrayOfUUID
        }
        this.updateInstitutionPrivateLibrary(data).then(res => {
          this.$refs.loadingModal.hide()
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Private folder "' + this.title + '" updated successfully.'
          })
          return this.$router.push({name: 'folderList'})
        })
      },

      getListOfUUIDsOfEnrolledUser () {
        var listOfUUIDs = []
        $.each(this.enrolledUserList, (i, user) => {
          listOfUUIDs.push(user.uuid)
        })
        return listOfUUIDs
      },

      searchUser () {
        this.refreshList()
      },

      refreshList () {
        this.userList = []
        this.getUsersForRole()
      }
    }
  }
</script>

<style scoped>
    .heading {
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 8px;
        height: 42px;
    }

    .special {
        background-color: #E3F4FF!important;
    }

    .action-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/folderManagement/components/FolderEdit.vue